export const faq = {
};
